export default __webpack_public_path__ + "static/media/wi-night-cloudy-windy.dc8f9504.svg";